import TabContext from '@mui/lab/TabContext';
import {Stack} from '@mui/material';
import {FC, SyntheticEvent, useState} from 'react';
import money from '../../../../assets/Money.svg';
import ruble from '../../../../assets/Ruble.svg';
import {BALANCE_PAYMENT_TITLES, BalancePaymentTab} from '../../constants/balance-payment.constants';
import {getTabComponents} from '../../helpers';
import {useCurrentUserAndCompanyBalance} from '../../hooks/useCurrentUserAndCompanyBalance';
import {BalanceHistory} from '../BalanceHistory';
import {BalanceReplenishment} from '../BalanceReplenishment';
import {DocumentsLayout} from '../DocumentsLayout';
import {
  BalanceCard,
  BalanceCardTitle,
  BalanceCardValue,
  ContentContainer,
  Header,
  HeaderTextBlock,
  PanelsContainer,
  Root,
  RubleIcon,
  StyledTabList,
  Subtitle,
  TabsContainer,
  Title,
} from './styles';

export const BalancePaymentContainer: FC = () => {
  const [value, setValue] = useState<BalancePaymentTab>('replenishment');
  const {data} = useCurrentUserAndCompanyBalance(() => undefined);
  const heading = BALANCE_PAYMENT_TITLES[value] || BALANCE_PAYMENT_TITLES.replenishment;
  const isHistory = value === 'history';
  const isReplenishment = value === 'replenishment';
  const {tabs, panels} = getTabComponents([
    {
      id: 0,
      label: 'ПОПОЛНЕНИЕ',
      value: 'replenishment',
      component: <BalanceReplenishment />,
    },
    {id: 1, label: 'ДОКУМЕНТЫ', value: 'documents', component: <DocumentsLayout />},
    {id: 2, label: 'ИСТОРИЯ', value: 'history', component: <BalanceHistory />},
  ]);

  const handleChange = (_: SyntheticEvent, newValue: string) => {
    setValue(newValue as BalancePaymentTab);
  };

  return (
    <Root>
      <Header>
        <HeaderTextBlock>
          <Title isHistory={isHistory}>{heading.title}</Title>
          <Subtitle>{heading.description}</Subtitle>
        </HeaderTextBlock>
        {isReplenishment && (
          <BalanceCard>
            <BalanceCardTitle>Текущий баланс</BalanceCardTitle>
            <Stack direction="row" alignItems="center" gap={2}>
              <img src={money} alt="Текущий баланс" width={42} height={42} />
              <Stack direction="row" alignItems="center">
                <BalanceCardValue>{data?.balance ?? 0}</BalanceCardValue>
                <RubleIcon src={ruble} alt="Рублей" width={30} height={30} />
              </Stack>
            </Stack>
          </BalanceCard>
        )}
      </Header>
      <ContentContainer isHistory={isHistory} isReplenishment={isReplenishment}>
        <TabsContainer>
          <TabContext value={value}>
            <StyledTabList onChange={handleChange}>{tabs}</StyledTabList>
            <PanelsContainer>{panels}</PanelsContainer>
          </TabContext>
        </TabsContainer>
      </ContentContainer>
    </Root>
  );
};
